import { render } from "./CreateServiceReport2.vue?vue&type=template&id=6a50155c"
import script from "./CreateServiceReport2.vue?vue&type=script&lang=js"
export * from "./CreateServiceReport2.vue?vue&type=script&lang=js"

import "./CreateServiceReport2.vue?vue&type=style&index=0&id=6a50155c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__